import React, { useEffect } from "react";
import "./BannerStyle.scss";
import { useState } from "react";
import { Link } from "react-router-dom";
import { VscUnmute } from "react-icons/vsc";
import { BiVolumeMute } from "react-icons/bi";
import { Col, Container, Row } from "react-bootstrap";
import bannerVd from "../../../Assets/Images/canva/clip.mp4";
import canvaLogo from "../../../Assets/Images/canva/canvaLogo.png";
const GoogleImg = require("../../../Assets/Images/ObonLAndingPageImage/googlePay.png");
const AppleImg = require("../../../Assets/Images/ObonLAndingPageImage/applePay.png");
const sectionImg = require("../../../Assets/Images/canva/canvaAbout.png");

function CanvaBanner() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    const video = document.getElementById("myVideo");
    if (video) {
      video.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const scrollToSection = (sectionId) => {
    const targetElement = document.querySelector(sectionId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="canvabanner" className="BannerImgOne">
      <Container className="h-100 position-relative" fluid>
        <Row className="h-100 px-4">
          <Col md={7} sm={12} className="mt-2">
            <Row className="h-100">
              <Col md={12} className="">
                <div className="mt-2">
                  <img
                    style={{ width: "25%" }}
                    src={canvaLogo}
                    alt="banner img"
                  />
                </div>
              </Col>
              <Col md={12}>
                <h2 className="heading mb-0 py-2">
                  Hassle-free cashless tipping is at your fingertips with EasyTipping.
                </h2>
                <p className="canvaText mb-0 py-2">
                  Our secure payment platform seamlessly integrates mobile
                  tipping for service workers, hospitality workers, businesses,
                  and enterprises.
                </p>
                <p className="canvaText mb-0 py-2">
                  Download the app, request a live demonstration for your
                  business, and start tipping digitally today!
                </p>
              </Col>
               <Row className="align-items-center bannerCenter mb-5">
              <Col lg={3} md={6} sm={7} xs={12} className="text-center">
              <button
                type="button"
                class="btn landingBtn w-100 py-2 btn-outline-warning border border-dark nowrap"
              >
                <Link
                  onClick={() => scrollToSection("#canvaContact")}
                  className="nomrateFont py-3 fw-bold text-dark nowrap w-100"
                >
                  Request A Demo
                </Link>
              </button>
            </Col>
            <Col lg={3} md={4} sm={7} xs={12} className="text-center">
              <button
                type="button"
                class="btn w-100 py-2 landingBtn btn-outline-warning border border-dark"
              >
                <Link
                  to="/welcome"
                  className="nomrateFont py-3 fw-bold text-dark  w-100"
                >
                  Get Started
                </Link>
              </button>
            </Col>
              <Col lg={3} md={4} sm={7} xs={12} className="">
                <div className="rounded-3 overflow-hidden   w-100">
                  <Link
                    to="https://apps.apple.com/us/app/easy-tipping-app/id6449997064"
                    className="btnBorder  btn p-0 rounded-3 overflow-hidden"
                  >
                    <img
                      className="w-100 rounded-3 overflow-hidden"
                      src={AppleImg}
                      alt="Google Button"
                    />
                  </Link>
                </div>
              </Col>
              <Col lg={3} md={4} sm={7} xs={12} className="">
                <div className="rounded-3 overflow-hidden  w-100">
                  <Link
                    to="https://play.google.com/store/apps/details?id=com.org.ObonApp.Fintech"
                    className="btnBorder w-100   btn p-0"
                  >
                    <img
                      className="w-100 rounded-3 overflow-hidden"
                      src={GoogleImg}
                      alt="Google Button"
                    />
                  </Link>
                </div>
              </Col>
           </Row>
            </Row>
          </Col>
          <Col lg={5} md={5} sm={12}>
            <div className="d-md-flex justify-content-center align-items-center mb-4  h-100">
              <div style={{ position: "relative" }}>
                <div className="mobFrame position-absolute BannerFrame text-center">
                  <div
                    className="mute-icon"
                    onClick={toggleMute}
                    style={{
                      position: "absolute",
                      bottom: "50px",
                      margin: "auto",
                      cursor: "pointer",
                      zIndex: "9999",
                    }}
                  >
                    {isMuted ? (
                      <span>
                        <BiVolumeMute color="red" size={25} />
                      </span>
                    ) : (
                      <span>
                        {" "}
                        <VscUnmute color="#499662" size={25} />
                      </span>
                    )}
                  </div>
                </div>
                <video muted="false" id="myVideo" autoPlay loop height="400">
                  <source src={bannerVd} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </Col>
       
         
          
       
          
         
          </Row>
   
      </Container>
    </section>
  );
}

export default CanvaBanner;
